var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { REMOTEDESKTOP_PRODUCT_CODE } from './constants';
import { GET_CSRF_TOKEN_URL, CSRF_PROTECTED_URLS, CSRF_HEADER_NAME } from './CsrfConstants';
var IPV4_TOKEN_HEADER_NAME = 'IPV4-TOKEN';
var instance = axios.create({
    // baseURL: (productCode == "rdp" ? 'http://dev.remotedesktop.com:8080/rpcnew/' : 'http://dev.remotepc.com:8080/rpcnew/'),
    baseURL: (productCode == REMOTEDESKTOP_PRODUCT_CODE ? 'https://login.remotedesktop.com/rpcnew/' : 'https://login.remotepc.com/rpcnew/'),
    // timeout: 1000,                       // should not use...affecting ajax request on page loading
    withCredentials: true
});
var instanceForIPV4Domain = axios.create({
    timeout: 10000,
    withCredentials: false
});
export function MakeGETRequest(url, params, headers) {
    return __awaiter(this, void 0, void 0, function () {
        var finalHeaders, addCsrfToken, csrfToken, _a, _b, configs, response, error_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    finalHeaders = __assign({}, (headers || {}));
                    addCsrfToken = isCsrfProtectedUrl(url);
                    if (!addCsrfToken) return [3 /*break*/, 2];
                    return [4 /*yield*/, getCSRFToken()];
                case 1:
                    csrfToken = _c.sent();
                    finalHeaders[CSRF_HEADER_NAME] = csrfToken;
                    _c.label = 2;
                case 2:
                    _a = finalHeaders;
                    _b = IPV4_TOKEN_HEADER_NAME;
                    return [4 /*yield*/, getIPv4Token()];
                case 3:
                    _a[_b] = _c.sent();
                    configs = {
                        headers: finalHeaders
                    };
                    _c.label = 4;
                case 4:
                    _c.trys.push([4, 6, , 7]);
                    return [4 /*yield*/, instance.get(url, {
                            params: params,
                            headers: configs.headers
                        })];
                case 5:
                    response = _c.sent();
                    return [2 /*return*/, response];
                case 6:
                    error_1 = _c.sent();
                    if (error_1.response && error_1.response.status === 401) {
                        console.log("401 Unauthorized");
                        window.location.href = "/rpcnew/logout";
                    }
                    return [2 /*return*/, Promise.reject(error_1)];
                case 7: return [2 /*return*/];
            }
        });
    });
}
export function MakePOSTRequest(url, data, headers) {
    return __awaiter(this, void 0, void 0, function () {
        var finalHeaders, addCsrfToken, csrfToken, _a, _b, configs, response, error_2;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    finalHeaders = __assign({}, (headers || {}));
                    addCsrfToken = isCsrfProtectedUrl(url);
                    if (!addCsrfToken) return [3 /*break*/, 2];
                    return [4 /*yield*/, getCSRFToken()];
                case 1:
                    csrfToken = _c.sent();
                    finalHeaders[CSRF_HEADER_NAME] = csrfToken;
                    _c.label = 2;
                case 2:
                    _a = finalHeaders;
                    _b = IPV4_TOKEN_HEADER_NAME;
                    return [4 /*yield*/, getIPv4Token()];
                case 3:
                    _a[_b] = _c.sent();
                    configs = {
                        headers: finalHeaders
                    };
                    _c.label = 4;
                case 4:
                    _c.trys.push([4, 6, , 7]);
                    return [4 /*yield*/, instance.post(url, data, configs)];
                case 5:
                    response = _c.sent();
                    return [2 /*return*/, response];
                case 6:
                    error_2 = _c.sent();
                    if (error_2.response && error_2.response.status === 401) {
                        console.log("401 Unauthorized");
                        window.location.href = "/rpcnew/logout";
                    }
                    return [2 /*return*/, Promise.reject(error_2)];
                case 7: return [2 /*return*/];
            }
        });
    });
}
export function MakeDELETERequest(url) {
    return instance.delete(url, {});
}
// Helper to check if URL needs CSRF protection
function isCsrfProtectedUrl(url) {
    return CSRF_PROTECTED_URLS.some(function (protectedUrl) { return protectedUrl.indexOf(url) > -1; });
}
function getCSRFToken() {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, MakePOSTRequest(getWEBAPPAPIAbsoluteURL(GET_CSRF_TOKEN_URL), {}, null)];
                case 1:
                    response = _a.sent();
                    if (response && response.data && response.data._rcft) {
                        return [2 /*return*/, response.data._rcft];
                    }
                    else {
                        console.error("CSRF token not found in response");
                        throw new Error("CSRF token not found in response");
                    }
                    return [2 /*return*/];
            }
        });
    });
}
function getIPv4Token() {
    return __awaiter(this, void 0, void 0, function () {
        var response, data, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, instanceForIPV4Domain.get('https://ip4.remotepc.com/')];
                case 1:
                    response = _a.sent();
                    data = response.data;
                    if (data && typeof data.token === 'string' && data.token.length > 0) {
                        return [2 /*return*/, data.token];
                    }
                    console.warn('IPv4 token not found in response');
                    return [3 /*break*/, 3];
                case 2:
                    error_3 = _a.sent();
                    console.warn('Failed to retrieve IPv4 token', error_3);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/, ''];
            }
        });
    });
}
// async function getIPv4Token(): Promise<string> {
//     try {
//         const response = await fetch('https://ip4.remotepc.com/');
//         if (!response.ok) {
//             console.warn(`Failed to retrieve IPv4 token: HTTP ${response.status}`);
//             return '';
//         }
//         const data = await response.json();
//         if (data && typeof data.token === 'string' && data.token.length > 0) {
//             return data.token;
//         }
//         console.warn('IPv4 token not found in response');
//     } catch (error) {
//         console.warn('Failed to retrieve IPv4 token', error);
//     }
//     return '';
// }
